import type { ApiModuleEndpoints } from '../types'

export const permissionApiEndpoints = {
  tree: {
    method: 'GET',
    path: '/permissions/tree',
    requiresAuth: true,
  },
  list: {
    method: 'GET',
    path: '/permissions',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
